import { axiosApi } from './index';
import { types, API_URL } from './types';

export const getServices = () => {
  const url = `${API_URL}/api/v1/service`;
  return (dispatch) => {
    let outputData = {};
    axiosApi.get(url, { validateStatus: false }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setGetServices(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        outputData['data'] = data.data;
        dispatch(setGetServices(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setGetServices({ status: 'danger', error: true, message }));
      });
  };
};

export const setGetServices = (data) => ({
  type: types.svcGetServices,
  payload: data,
});

export const createService = (formData) => {
  const url = `${API_URL}/api/v1/service/create`;
  return (dispatch) => {
    let outputData = {};
    axiosApi
      .post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        validateStatus: false,
      })
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          dispatch(setCreateService(outputData));
        } else {
          outputData['status'] = 'success';
          outputData['message'] = data.message;
          outputData['data'] = data.data;
          dispatch(setCreateService(outputData));
        }
      })
      .catch((error) => {
        outputData['status'] = 'danger';
        outputData['message'] = 'Error al crear servicio';
        dispatch(setCreateService(outputData));
      });
  };
};

export const setCreateService = (data) => ({
  type: types.svcCreateService,
  payload: data,
});

export const updateService = (serviceId, formData) => {
  const url = `${API_URL}/api/v1/service/edit/${serviceId}`;
  return (dispatch) => {
    let outputData = {};
    axiosApi
      .put(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        validateStatus: false,
      })
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          dispatch(setUpdateService(outputData));
        } else {
          outputData['status'] = 'success';
          outputData['message'] = data.message;
          outputData['data'] = data.data;
          dispatch(setUpdateService(outputData));
        }
      })
      .catch((error) => {
        outputData['status'] = 'danger';
        outputData['message'] = 'Error al actualizar servicio';
        dispatch(setUpdateService(outputData));
      });
  };
};

export const setUpdateService = (data) => ({
  type: types.svcUpdateService,
  payload: data,
});

export const deleteServiceById = (serviceId) => {
  const url = `${API_URL}/api/v1/service/${serviceId}`;
  return (dispatch) => {
    let outputData = {};
    axiosApi.delete(url, { validateStatus: false }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setDeleteServiceById(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        outputData['data'] = data;
        outputData['serviceId'] = serviceId;
        dispatch(setDeleteServiceById(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setDeleteServiceById({ status: 'danger', error: true, message }));
      });
  };
};

export const setDeleteServiceById = (data) => ({
  type: types.svcDeleteServiceById,
  payload: data,
});
